module.exports = __webpack_public_path__ + "static/media/p2008sherbim.0ce82889.jpg";